module.exports = __webpack_public_path__ + "static/media/nancy.330ee974.png";